<template>
  <Content class="col-span-full" :title="$route.name">
    <Notice class="mb-8">
      {{ $t("VEHICLE_HISTORY_REPORT_NOTE") }}
    </Notice>
    <customerVehicle
      type="driver"
      @tableData="tableData = $event"
      @tableLoading="tableLoading = $event"
    />

    <driverTable class="mt-8" :tableData="tableData" :loading="tableLoading" />
  </Content>
</template>

<script>
import Notice from "@/components/elements/notice";
import driverTable from "@/components/reports/history/driverTable.vue";
import customerVehicle from "@/components/reports/history/customerVehicle.vue";

export default {
  data() {
    return {
      tableData: [],
      tableLoading: false,
    };
  },

  components: {
    Notice,
    driverTable,
    customerVehicle,
  },
};
</script>
